import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

type Props = {
  color: string;
  animation: boolean;
};

export const AudioWave: React.FC<Props> = ({ color, animation }) => {
  const [heights, setHeights] = useState<any[]>([]);
  const theme = useTheme();
  const classes = useStyles(theme)();

  useEffect(() => {
    if (animation) {
      const interval = setInterval(() => {
        setHeights(generateWave(animation));
      }, 250);
      return () => clearInterval(interval);
    } else {
      setHeights(generateWave(animation));
    }
    // eslint-disable-next-line
  }, []);

  const generateWave = (randomHeights: boolean) => {
    return new Array(70)
      .fill({})
      .map(() => (randomHeights ? `${Math.max(10, Math.floor(Math.random() * 100))}%` : '12px'));
  };

  return (
    <Box
      className={classes.waveBox}
      height={60}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
    >
      {heights &&
        heights.map((height: string, index: number) => (
          <Box key={index} bgcolor={color} width={3} height={height} borderRadius={1} />
        ))}
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    waveBox: () => ({
      backgroundColor: theme.palette.kinder.lighter,
      padding: '15px 20px',
      height: '100% !important'
    })
  }));
